import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourses } from "../../utils/Apis";
import Loader from "../commonComponents/Loader";
import { safeTruncate } from "../../utils/truncate";
import CourseDetailsModal from "../commonComponents/courseDetailsModal";

// // Dummy data for courses
// const dummyCourses = [
//   {
//     id: 1,
//     title: "Web Development Masterclass",
//     description: "Build modern web applications using HTML, CSS, JS, and React.",
//     duration: "6 months",
//     img: "https://via.placeholder.com/300x200",
//   },
//   {
//     id: 2,
//     title: "Digital Marketing Essentials",
//     description: "Master SEO, Social Media, Email Marketing to grow your business.",
//     duration: "4 months",
//     img: "https://via.placeholder.com/300x200",
//   },
//   {
//     id: 3,
//     title: "Graphic Design Bootcamp",
//     description: "Become a pro designer using Photoshop, Illustrator, and more.",
//     duration: "5 months",
//     img: "https://via.placeholder.com/300x200",
//   },
// ];

function CourseComponent() {
  const dispatch = useDispatch();
  const courses = useSelector((state) => state.data.courses?.courses);
  const loading = useSelector((state) => state.data.loading);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleLearnMore = (course) => {
    setSelectedCourse(course);
    setOpen(true);
  };

  // This would be replaced by an actual API call
  useEffect(() => {
    // Simulate fetching data from an API
    if (!courses) {
      dispatch(fetchCourses());
    }
  }, []);

  if (loading) {
    return <Loader fullPage />;
  }

  return (
    <Box sx={{ p: 5, backgroundColor: "#F0F4F8" }}>
      <Typography
        fontSize={{ xs: "1.3rem", sm: "2rem", md: "3.3rem" }}
        variant="h3"
        sx={{
          fontWeight: "bold",
          color: "#333",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        Introducing Our Career Ready Courses
      </Typography>
      <Typography
        fontSize={{ xs: "0.9rem", sm: "1rem", md: "1.5rem" }}
        sx={{
          color: "#777",
          marginBottom: "16px !important",
          // marginBottom: "1.5rem",
          textAlign: "center",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: 1.5,
        }}
      >
        Join our diverse courses in web development, digital marketing, Tally,
        and more! Learn from expert instructors and gain practical skills for
        your career success.
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {courses?.map((course) => (
          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <Card
              sx={{
                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 16px 30px rgba(0, 0, 0, 0.15)",
                },
                borderRadius: "16px",
                overflow: "hidden",
                maxWidth:"25rem",
                minWidth:"21rem",
              }}
            >
              <Box sx={{ position: "relative", height: "200px" }}>
                <img
                  src={course.coursePic}
                  alt={course.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: "40%",
                    display: "flex",
                    gap: 2,
                    background:
                      "linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)",
                    color: "white",
                    p: 2,
                  }}
                >
                  <Typography variant="subtitle2">
                    {course.duration.value}
                  </Typography>
                  <Typography variant="subtitle2">
                    {course.duration.unit}
                  </Typography>
                </Box>
              </Box>

              <CardContent sx={{ textAlign: "center", p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#34495E",
                    mb: 1,
                    fontFamily: "Roboto, sans-serif",
                  }}
                >
                  {course.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#7F8C8D", mb: 2 }}>
                  {safeTruncate(course.description, 80)}
                </Typography>
                <Box
                  sx={{
                    justifyContent: "space-evenly",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{
                      // backgroundColor: "#2980B9",
                      border: "1px solid #333",
                      color: "#333",
                      "&:hover": {
                        backgroundColor: "#333",
                        color: "#fff",
                      },
                      padding: "8px 20px",
                      borderRadius: "24px",
                      textTransform: "none",
                    }}
                    onClick={() => handleLearnMore(course)}
                  >
                    Learn More
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#333",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#black",
                      },
                      padding: "8px 20px",
                      borderRadius: "24px",
                      textTransform: "none",
                    }}
                    onClick={() => navigate("/admission")}
                  >
                    Enroll Now
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <CourseDetailsModal
        open={open}
        handleClose={() => setOpen(false)}
        course={selectedCourse}
      />
    </Box>
  );
}

export default CourseComponent;
